import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ExportModalBase } from '../export-modal.base';
import { ExportManager } from '../../../managers/export.manager';
import { FormControl } from '@angular/forms';
import { ViewStateEnum } from '../../../../core/enums/view-state.enum';
import { ExportTypeEnum } from '../../../../../../../../../common/src/enums/export-type.enum';

@Component({
  selector: 'app-export-modal-salary-dividend',
  templateUrl: './export-modal-salary-dividend.component.html',
  styleUrls: ['./export-modal-salary-dividend.component.scss'],
  standalone: false,
})
export class ExportModalSalaryDividendComponent extends ExportModalBase implements OnInit, OnDestroy {

  public formControl = new FormControl<ExportTypeEnum>(ExportTypeEnum.Optitax);

  constructor(
    activeModal: NgbActiveModal,
    exportManager: ExportManager,
  ) {
    super(activeModal, exportManager);
  }

  ngOnDestroy(): void {
  }

  ngOnInit(): void {
  }

  async export() {
    if (!this.calculationResponse) {
      return;
    }

    if (!this.formControl.value) {
      this.error = 'Vous devez sélectionner un format d\'exportation.';
      return;
    }

    this.exportState = ViewStateEnum.Refreshing;

    switch (this.formControl.value as ExportTypeEnum) {
      case ExportTypeEnum.Optitax:
        this.exportManager.exportOptitax(this.calculationResponse);
        break;
      case ExportTypeEnum.XLSX:
      case ExportTypeEnum.XLS:
      case ExportTypeEnum.CSV:
        await this.exportManager.exportExcel(this.calculationResponse);
        break;

      case ExportTypeEnum.PDF:
        await this.exportManager.exportPdf(this.calculationResponse);
        break;
    }

    setTimeout(() => {
      this.exportState = ViewStateEnum.Ready;
    }, 1000);
  }

}
